import actionTypes from '../actionTypes';

export function requestTournamentCasinoRegister(params, cb) {
  return {
    type: actionTypes.TOURNAMENT_CASINO_REGISTER_REQUEST,
    value: params,
    cb
  };
}

export function successTournamentCasinoRegister(response) {
  return {
    type: actionTypes.TOURNAMENT_CASINO_REGISTER_SUCCESS,
    value: response.data.result.tournament,
  };
}

export function resetSuccessfullTournamentCasinoRegister() {
  return {
    type: actionTypes.TOURNAMENT_CASINO_REGISTER_SUCCESS_RESET,
  };
}

export function failTournamentCasinoRegister(message, e) {
  return {
    type: actionTypes.TOURNAMENT_CASINO_REGISTER_FAIL,
    exception: e,
    failed: message,
  };
}

export function requestTournamentCasinoUnregister(params) {
  return {
    type: actionTypes.TOURNAMENT_CASINO_UNREGISTER_REQUEST,
    value: params,
  }
}

export function successTournamentCasinoUnregister(response) {
  return {
    type: actionTypes.TOURNAMENT_CASINO_UNREGISTER_SUCCESS,
    value: response.data.result.tournament,
  };
}

export function resetSuccessfullTournamentCasinoUnregister() {
  return {
    type: actionTypes.TOURNAMENT_CASINO_UNREGISTER_SUCCESS_RESET,
  }
}

export function failTournamentCasinoUnregister(message, e) {
  return {
    type: actionTypes.TOURNAMENT_CASINO_UNREGISTER_FAIL,
    exception: e,
    failed: message,
  }
}